<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <h2>
          <i v-if="detailData.onlineStatus==0" class="redDot"></i>
          <i v-if="detailData.onlineStatus==1" class="greenDot"></i>
          {{detailData.onlineStatus==0?"离线":detailData.onlineStatus==1?"在线":"---"}}
        </h2>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;" @tab-click="tabClick">
          <el-tab-pane label="详情">
            <h1>网关详情</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>编号</label> <br />
                  <span>{{ detailData.code }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>名称</label> <br />
                  <span>{{ detailData.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>品牌</label> <br />
                  <span>{{
                    detailData.brandObj != null ? detailData.brandObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>型号</label> <br />
                  <span>{{
                    detailData.modelObj != null ? detailData.modelObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>操作系统</label> <br />
                  <span>{{
                    detailData.osObj != null ? detailData.osObj : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>北向联网方式（网关到云平台）</label> <br />
                  <span>{{
                    detailData.northLinkTypeObj != null
                      ? detailData.northLinkTypeObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>南向联网方式（网关到设备）</label> <br />
                  <span>{{
                    detailData.southLinkTypeObj != null
                      ? detailData.southLinkTypeObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>备注</label> <br />
                  <span>{{
                    detailData.remarks != null ? detailData.remarks : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>{{
                    detailData.createId != null ? detailData.createId : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="协议">
            <h1>网关协议</h1>
            <el-row class="formRow">
              <el-col :span="12" v-if="agreementShow">
                <div class="grid-content bg-purple">
                  <label>IP地址</label> <br />
                  <span>{{agreement.ipAddress}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>端口</label> <br />
                  <span>{{agreement.port}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>用户名</label> <br />
                  <span>{{agreement.userName}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>身份密钥</label> <br />
                  <span>{{agreement.password}}</span>
                </div>
              </el-col>
              <p style="line-height:50px;margin-left:20px;" v-if="!agreementShow">{{agreementTips}}</p>
            </el-row>
          </el-tab-pane>

        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        routeList: this.$route.meta.routeList,
        ids: this.$route.query.id,
        detailData: {},
        agreement: {}, //协议
        agreementShow: false,
        agreementTips: '',
      };
    },
    created() {},
    methods: {

      //格式化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },

      //获取网关详情
      getPlatformMduModule() {
        API.platformMduModule(this.ids).then(res => {
          if (res.code == 1) {
            this.detailData = res.data;
          }
        });
      },
      //选择对应的tab时触发事件
      tabClick(val) {
        let _API = API
        let _this = this
        if (val.label == "协议") {
          //根据网关id查找网关协议
          _API.platformMduModuleGatewayConfig(_this.ids).then(res => {
            if (res.code == 1) {
              this.agreementShow = true
              _this.agreement = res.data;
            } else {
              this.agreementShow = false
              this.agreementTips = res.msg;
            }
          });
        }
      },
      //操作下拉
      handleCommand(para) {
        if (para == "edit") {
          //编辑
          this.$router.push({
            path: "/device/gatewayAdd",
            query: {
              id: this.ids,
              flag: 'edit'
            }
          });
        } else if (para == "del") {
          //删除
          let para = {
            ids: this.ids
          }
          this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            API.delPlatformMduModule(para).then(res => {
              if (res.code == 1) {
                this.$message.success('删除成功');
                this.$router.push({
                  path: "/device/gatewayManagement",
                });
              } else {
                this.$message.error('删除失败');
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      }
    },
    mounted() {
      this.getPlatformMduModule();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/gatewayDetails.vue